// skyhawks-peninsula-internal-web/src/api/tiers.js

import { get, post, put, deleteApi } from "./api"

// Signals (complaints and positive signals)
export async function addSignal(coachId, data) {
  try {
    return await post(`admin/coach/${coachId}/signal`, data)
  } catch (error) {
    return { error }
  }
}

export async function getSignals(coachId, year, season) {
  try {
    return await get(`admin/coach/${coachId}/signals?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}

export async function deleteSignal(signalId) {
  try {
    return await deleteApi(`admin/signal/${signalId}`)
  } catch (error) {
    return { error }
  }
}

// Endorsements
export async function setEndorsement(coachId, data) {
  try {
    return await put(`admin/coach/${coachId}/endorsement`, data)
  } catch (error) {
    return { error }
  }
}

export async function getEndorsement(coachId, year, season) {
  try {
    return await get(`admin/coach/${coachId}/endorsement?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}

// Tier Summary
export async function getTierSummary(year, season) {
  try {
    return await get(`admin/tiers/summary?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}

export async function getCoachTierDetail(coachId, year, season) {
  try {
    return await get(`admin/coach/${coachId}/tier?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}

export async function getMyTierDetail(year, season) {
  try {
    return await get(`coach/tier?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}
